import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EmploymentFinder/EmploymentFinderHomeTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import Tooltip from '../../moreCore/UI/Floating/Tooltip';
import { TicketTypes } from "./TicketTypes";
import TicketRequestedList from './TicketRequestedList/TicketRequestedList';
import TicketContingentView from './TicketContingentView/TicketContingentView';

class TicketPoolAgenda extends compose(AgendaViewBase<any>, _TabEnabledMixin) {
	//templateString = template;

    itemClickDlg: MdsLax<InstanceType<typeof GenericDialog>>;

    private tableFormatterHeadings(originalHeading: string, colName: string) {
        switch (colName) {
            default:
                return false;


                break;
        }
    }

    private tableFormatter(cell: StaticTable.StaticTableCell<TicketTypes.TicketContingentEntity>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {
           
            default:
                node.innerHTML = value;
                break;

            case "type":
                node.innerHTML = value;
                node.innerHTML += " (" + entity.tickets_applied + "/" + entity.tickets_plan + ")";

                this.UiModder.domClass.toggle(node, "warningTXT", entity.tickets_applied == entity.tickets_plan);
                return true;
                break;

            case "myRequests":
            case "myTickets":
                let list: Array<TicketTypes.TicketEntity> = [];
                let myId = this.getCurrentEmployeeId();
                for (let ticket of entity.tickets) {
                    if (colName == "myRequests") {
                        if (ticket.ref_address_3 && ticket.ref_address_3.ID == myId) {
                            list.push(ticket);
                        }
                    }
                    else if (colName == "myTickets") {
                        if (ticket.ref_address_1 && ticket.ref_address_1.ID == myId) {
                            list.push(ticket);
                        }
                        else if (ticket.ref_address_2 && ticket.ref_address_2.ID == myId) {
                            list.push(ticket);
                        }
                    }
                }
                if (list && list.length) {
                    let container = this.UiModder.domConstruct.create("div", {
                        className: "flex_row_center flex_gapSmall"
                    }, node, "only");

                    for (let entry of list) {
                        let bobble = this.UiModder.domConstruct.create("div", {
                            className: "paddingSmall round border",
                            innerHTML: entry.tickets_applied
                        }, container);

                        if (entry.ref_ev_calc_ticket_02_status?.coloration) {
                            this.UiModder.domStyle.set(bobble, "backgroundColor", entry.ref_ev_calc_ticket_02_status.coloration.BackColor.Hex);
                            this.UiModder.domStyle.set(bobble, "color", entry.ref_ev_calc_ticket_02_status.coloration.TextColor.Hex);

                        }

                        if (entry.tooltip) {
                            let tooltip = new Tooltip();
                            tooltip.setup({
                                targetnode: bobble,
                                content: entry.tooltip,
                                enableClick: true,
                                //delayMS: 100
                            });
                        }

                    }
                }
                return true;

                break;
        }

        return false;
    }

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {
   
    }

    private _onClick_Row(row: StaticTable.StaticTableRow<TicketTypes.TicketContingentEntity>) {
        this.showTicketContingentDetail(row.rowGroup.entity);
    }

    private showTicketContingentDetail(entity: TicketTypes.TicketContingentEntity) {

        let view = new TicketContingentView();

        let dlg = new GenericDialog();
        dlg.show(
            view,
            entity.ref_ev_planning.gDisp_1,
            null,
            null,
            "close"
        );

        //view.setEntity(entity);
        view.loadData(entity.ID);

        view.on("change", lang.hitch(this, this.loadData));
    }

  
    requestedTickets(entity: TicketTypes.TicketContingentEntity) {
        let dlg = new GenericDialog();

        let form = new TicketRequestedList();
        form.getListData(entity.ID);

        dlg.show('', entity.ref_ev_planning.gDisp_1, null, null, "close", lang.hitch(this, this._onCloseDetailsDlg_Callback, dlg));
        dlg.addNodeToContent(form.domNode, "first");
    }


    _onCloseDetailsDlg_Callback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, result: Number) {
        if (result == 99) { // Datensatz wurde gespeichert - neu laden!
            this.loadData();
        }
    }

    _onTicketRequestSaved(dlg: MdsLax<InstanceType<typeof GenericDialog>>): void {
        dlg.close(99);
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";
      
        this.setTableHeadingFormatter(lang.hitch(this, this.tableFormatterHeadings));

        
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        if (!this.hasFeature("TicketPool/Agenda")) {
            alert("missing feature for ticketpool/agenda - no privilege");
            return;
        }

        this.setupAgendaViewWithCallfunction(
            "Webtool_API_TicketPool__GetFilterOptionsJSON",
            "Webtool_API_TicketPool__GetTicketContingentsListJSON",
            lang.hitch(this, this._onClick_Row),
            lang.hitch(this, this.tableFormatter), // Standard-Formatter
            null,
            null,
            null,
            null,
            [{
                name: "mode",
                value: "agenda"
            }]
        );

        this.setStandbyLoadingTexts(this.translate("TicketPool_Agenda_LoadingText"));

    }
}

export default mdsWidget(TicketPoolAgenda);